import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import type { OktaClient } from '../types';
import { BusyIndicator, checkCookieIsSet } from '@fctg-corporate/smartscript-core';
import { checkTokenValidity } from '../lib/utils';

type AuthGateProps = {
	oktaClients: OktaClient[];
	children: JSX.Element;
};

const AuthGate: React.FC<AuthGateProps> = ({ oktaClients, children }) => {
	const [allPresent, setAllPresent] = useState<boolean | null>(null);

	const fallbackPath = oktaClients[0]?.path ?? '/';

	useEffect(() => {
		(async () => {
			const results = await Promise.all(
				oktaClients.map(async ({ oktaAuth, tokenName }) => {
					const tokenIsValid = await checkTokenValidity(oktaAuth, tokenName);
					const cookieIsSet = checkCookieIsSet(tokenName);

					return tokenIsValid && cookieIsSet;
				}),
			);

			const allTokensAndCookiesPresent = results.every(Boolean);

			setAllPresent(allTokensAndCookiesPresent);

			if (allTokensAndCookiesPresent) {
				localStorage.removeItem('smartscript');
				localStorage.removeItem('smartscriptLoginQueue');
				window.close();
			}
		})();
	}, [oktaClients]);

	if (allPresent === null) {
		return <BusyIndicator label="Checking that all requested resources have been authenticated..." />;
	}

	if (!allPresent) {
		return <Navigate to={fallbackPath} replace />;
	}

	return children;
};

export default AuthGate;
